export declare interface NameValue {
    name: string;
    value: any;
}

export interface Stack {
    galstack: string;
}

export const constructionUtil = {


    /**
     * env and stack from possibly existing path segment parameters in url.
     *
     * Example:
     *   url: http://localhost:4200/construction-insurance/?galstack=PE2
     *   result: { galstack: "PE6"}
     *
     */

    isProdStage(hostname: string): boolean {
        return ['baloise', 'www'].includes(this.getAppStage(hostname));
    },

    getAppStage(hostname: string) {
        const subdomain = hostname.substring(0, hostname.indexOf('.'));
        return subdomain.includes('-www') ? subdomain.substring(0, hostname.indexOf('-')) : subdomain;
    },

    getIsFL(plz: string | undefined) {
        if (plz === null || plz === undefined) {
            return false;
        }
        const plzAsNumber: number = parseFloat(plz as string);
        return plzAsNumber >= 9485 && plzAsNumber <= 9498;
    },

    getStage(hostname: string, href: string) {
        if (hostname.includes('baloise.ch')) {
            return this.isProdStage(hostname) ? 'prod' : this.getAppStage(hostname);
        } else if (hostname.includes('localhost')) {
            return 'local';
        } else {
            const subDomainPart = hostname.split('.')[0];
            return this.getOpenshiftNames(subDomainPart)[5];
        }
    },

    getOpenshiftNames(hostname: string) {
        return hostname.split('-');
    },

    getStack(hostname: string, href: string) {
        if (this.isIntegrated(hostname)) {
/*            if (href.includes('test-')) {
                return 'pe2';
            } */
            return undefined;
        } else if (hostname.includes('localhost')) {
            return this.getStackFromUrl(href);
        } else {
            const searchString = 'galstack=';
            let stack: string | undefined;
            if (href.includes(searchString) && !this.isProdStage(hostname)) {
              stack = this.getStackFromUrl(href);
            } else {
                stack = this.getOpenshiftNames(hostname)[4];
            }
            return stack === 'wad' ? undefined : stack;
        }
    },

    isIntegrated(hostname: string) {
        return hostname.includes('baloise.ch');
    },

    getStackFromUrl(href: string) {
        const searchString = 'galstack=';
        if (href.includes(searchString)) {
            const idx = href.indexOf(searchString) + searchString.length;
            const valueLength = 3;
            return href.substr(idx, valueLength);
        } else {
            return undefined;
        }
    },

    getBaseUrl(hostname: string, href: string) {
        const stageUrls: { [key: string]: string } = {
            local: 'http://localhost:9098/construction',
            test: 'https://test-api.baloise.ch/construction',
            int: 'https://int-api.baloise.ch/construction',
            acc: 'https://acc-api.baloise.ch/construction',
            prod: 'https://api.baloise.ch/construction',
            undefined: '',
        };
        const stage = this.getStage(hostname, href);
        if (stage) {
            return stageUrls[stage];
        } else {
            return stageUrls.local;
        }
    },
};
